/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'table-insert-before': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M22 14a2 2 0 00-2-2H4a2 2 0 00-2 2v7h2v-2h4v2h2v-2h4v2h2v-2h4v2h2v-7M4 14h4v3H4v-3m6 0h4v3h-4v-3m10 0v3h-4v-3h4m-9-4h2V7h3V5h-3V2h-2v3H8v2h3v3z"/>'
  }
})
